
import { fetchGetJson, fetchPost } from "../../utils/fetch-json.js"

export const LikeService = {
    like: (recordId: string) =>
        fetchPost(`/v1/r/${recordId}/like`),

    unlike: (recordId: string) =>
        fetchPost(`/v1/r/${recordId}/unlike`),

    getLikedUsers: (recordId: string) =>
        fetchGetJson(`/v1/r/${recordId}/listLiked`)
}
